<template lang="pug">
v-container(class="tw-pt-0 tw-bg-gray-300 tw-h-full tw-max-h-full tw-overflow-x-hidden tw-overflow-y-hidden tw-pb-10" fluid)
  v-row(class="tw-bg-white tw-text-gray-700 tw-shadow-md")
    v-col(class=" tw-pt-1" cols="12" md="")
      v-row
        v-col(class="pt-0 pb-0")
          div
            span(class=" tw-font-bold") 
              |
              | {{ opp.name }}
            span(class=" tw-italic tw-font-hairline")
              | ({{ opp.email }})
          div
            | {{ opp.phone }}
    v-col(class=" tw-pt-0" cols="12" md="3")
      v-row
        v-col(class="pt-0 pb-0")
          div
            span(class=" tw-font-bold") Stage:
            | {{ opp.stage }}
          div
            span(class=" tw-font-bold") Value:
            | {{ opp.value }}
  v-row(class="tw-max-h-full tw-h-full tw-overflow-scroll lg:tw-overflow-hidden tw-h-auto tw-pb-32") 
    |
    v-col(md="4" cols="12" class="pa-0 tw-bg-white tw-shadow-md tw-rounded tw-my-2 tw-mx-2")
      v-row(dense)
        v-col(class=" tw-text-center tw-font-bold")
          | About
      v-row(dense class=" ")
        v-col(class="  tw-text-sm tw-pb-64 ")
          span(v-html="opp.description")
    v-col(
      md=""
      cols="12"
      class="pa-0 tw-h-full tw-max-h-full tw-overflow-hidden tw-bg-white tw-shadow-md tw-rounded tw-my-2 tw-mx-2"
    )
      v-row(dense)
        v-col(class=" tw-text-center tw-font-bold tw-bg-white tw-overflow-hidden my-0 ")
          | Pitched
      v-row(dense class="tw-h-full tw-max-h-full")
        v-col(class="tw-h-screen tw-overflow-scroll" id="pitched-list")
          div(v-for="(goods, index) in opp.goods" :key="index")
            kubiqa-goods-preview(v-if="opp.stage != 1" :goods="goods")
    v-col(md="" cols="12" class="pa-0 tw-h-full tw-overflow-hidden tw-bg-white tw-shadow-md tw-rounded tw-my-2 tw-mx-2")
      v-row(dense)
        v-col(class=" tw-text-center tw-font-bold")
          | Activity
      v-row
        v-col(class="tw-max-h-full tw-overflow-scroll")
          kubiqa-activity
</template>

<script>
export default {
  props: {
    opp: {
      type: Object,
      default: null,
    },
  },
  mounted: function () {
    this.fake();
  },
  methods: {
    fake() {
      this.opp.description = this.$faker().lorem.paragraphs(2, '</br></br>');
      this.opp.budget = this.$faker().finance.amount(30000, 300000, 0, '$');
      var items = this.$faker().datatype.number({ min: 1, max: 4 });
      for (let index = 0; index < items; index++) {
        var goods = {};
        goods.name = this.$faker().name.findName();
        goods.image = this.sampleWebsiteImage('listing', 300, 200, index);
        goods.bedrooms = this.$faker().datatype.number({ min: 1, max: 4 });
        goods.bathrooms = this.$faker().datatype.number({ min: 1, max: 4 });
        goods.price = this.$faker().finance.amount(30000, 300000, 0, '$');
        goods.address = this.$faker().address.streetAddress();
        this.opp.goods.push(goods);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.v-divider {
  border-top: 1px solid #dadada !important;
}
.v-toolbar .v-toolbar__content {
  margin-left: 0px !important;
  margin: 0px !important;
}
</style>
